export const ROUTER_PAGE_403 = '/error/403';

export const uriConsts = {
  admin: '/admin',
  auth: {
    login: '/auth/login', // trang đăng nhập pos | meta
    callback: '/auth/callback', // api handshake sau khi nhận code/token
    requestPerms: '/auth/requestperms',
    fbReauth: '/auth/fbreauth',
    threadscallback: '/auth/threadscallback',
    tiktokbusiness: '/auth/tiktokbusiness',
    fbReauthMetaCapi: '/auth/fbreauth2',
    shopeecallback: '/auth/shopeecallback',
    lazadacallback: '/auth/lazadacallback',
    whatsappcallback: '/auth/whatsappcallback',
    marketingLogin: '/auth/loginmarketing',
  },
  login: '/login', // trang chọn page
  logout: '/auth/logout',
  register: '/auth/register',
  profile: '/auth/profile',
  customer: {
    CUSTOMER_INDEX: '/customer',
    LIST: '/business/customer/list',
  },
  user: {
    loadPermissions: '/user/load/permissions',
  },
  product: {
    itemIndex: '/product/item/index',
  },
  shopify: {
    listShop: '/shopify/shopify/listshop',
    importAudience: '/shopify/shopify/importaudience',
    shopifyCallback: '/shopify/callback',
  },
  report: {
    DASHBOARD_INDEX: '/report/dashboard/index',
    DASHBOARD_PAGE: '/report/page/index',
    DASHBOARD_INTERACTIVE: '/report/interact/index',
    DASHBOARD_STAFF: '/report/staff/index',
    DASHBOARD_STAFF_SPLIT_CONVERSATION: '/report/staff/splitconversation',
    DASHBOARD_ACTIVITY: '/report/activity/index',
    STAFF_ACTIVITY: '/report/staff/activity',
    DASHBOARD_TAG: '/report/tag/index',
    DASHBOARD_TAG_2: '/report/tag2/index',
    TAG_USAGE_CURRENT: '/report/tag/usagecurrent',
    DASHBOARD_POST: '/report/post/index',
    DASHBOARD_FBAD: '/report/fbad/index',
    FBAD_ADACCOUNT: '/report/fbad/adaccount',
    DASHBOARD_METABIZ: '/report/metabiz/index',
    DASHBOARD_LIVESHOPPING: '/report/liveshopping/index',
    DASHBOARD_LIVESTREAMS: '/report/livestreams/index',
    DASHBOARD_LIVESTREAMS_DESCRIPTION: '/report/livestreams/descriptionlive',
    DASHBOARD_LIVESTREAMS_DETAIL: '/report/livestreams/detaillive',
    DASHBOARD_LIVESTREAMS_METHOD_BUY: '/report/livestreams/getmethodbuy',
    DASHBOARD_LIVESTREAMS_REVENUE_METHOD: '/report/livestreams/getrevuenuemethod',
    DASHBOARD_LIVESTREAMS_REVENUE: '/report/livestreams/loadrevenuelive',
    DASHBOARD_LIVESTREAMS_PRODUCT: '/report/livestreams/product',
    INTERACTIVE_DASHBOARD: '/report/interact/dashboard',
    INTERACTIVE_30_DAY: '/report/interact/interactive',
    DASHBOARD_MSG_6_MONTH: '/report/dashboard/msg6monthsreport',
    SPLIT_INDEX: '/report/split/index',
    GET_CONVERSATION_SPLIT_HISTORY: '/report/conversationsplitreport/getreport',
    META_CAPI_STATUS: '/report/metacapi/metacapibytatus',
    META_CAPI: '/report/metacapi/index',
    FB_ADS_INDEX: '/report/fbad/index',
    FB_ADS_BY_AD: '/report/fbad/ads',
    DASHBOARD_THREADS: '/report/threads/index',
    SAVE_LIVESTREAM_TARGET: '/report/livestreams/savetarget',
    RESEND_ORDER: '/report/facebook/resendorder',
    REPORT_FMM: '/admin/meta/reportfmm'
  },
  chat: {
    CONVERSATION_INDEX: '/conversation',
    GET_POSTS_IN_DB: '/chat/getpostsindb',
    FACEBOOK_POST_MANAGE: '/chat/facebook/postmanage',
    FACEBOOK_CHECK_LIVE_ADS: '/chat/facebook/checkliveads',
    SHOPEE_GET_VOUCHER_LIST: '/chat/shopee/getvoucherlist',
    CUSTOMER_LIST: '/chat/customer/list',
    ORDER_DRAFT: '/chat/orderdraftlist'
  },
  feature: {
    INDEX: '/feature',
    // chatbot script list
    CHATBOT_LIST: '/chatbot/script/list',

    // chatbot automation calender
    CHATBOT_AUTOMATIONCALENDER: '/feature/chatbot/chase/list',
    // chatbot automation inbox
    CHATBOT_AUTOMATIONINBOX: '/feature/chatbot/automationInbox',
    // chatbot audience
    CHATBOT_AUDIENCE: '/meta/audience/index',
    // chatbot marketing
    CHATBOT_MARKETING: '/chatbot/marketing/index',
    // chatbot utility message
    CHATBOT_UTILITYMESSAGE: '/chatbot/utilitymessage',
    // chatbot ecom customer care
    CHATBOT_ECOMCUSTOMERCARE: '/chatbot/ecomorderautomessage/index',
    // meta business calling
    CALLING_CHECK_STATUS: '/feature/calling/checkstatus',
    CALLING_SETTING: '/feature/calling/setting',
    METABIZ_INTRO: '/feature/metabiz/intro',
    METABIZ_CHECK_STATUS: '/feature/metabiz/checkstatus',
    METABIZ_REPORT: '/feature/metabiz/report',
  },
  live: {
    //shoppingfb
    LIVE_CHAT_SHOPPING_FB: '/live/shoppingfb',
    // shopping
    LIVE_CHAT_SHOPPING_LIST: '/live/shopping/list',
    LIVE_CHAT_SHOPPING_ADD: '/live/shopping/add',
    LIVE_CHAT_SHOPPING_EDIT: '/live/shopping/edit',
    // livestream
    LIVE_CHAT_LIVESTREAM: '/live/livestream/index',
    // setting
    LIVE_CHAT_SETTING: '/live/setting/index',
    // print comments
    LIVE_PRINT_COMMENTS: '/live/printcomments',
    // check live ads
    LIVE_VIDEO_ADS: '/live/checkliveads/index',
    // live comment
    EXPORT_LIVE_COMMENT: '/live/livestream/exportcomment',
    // livescript
    LIVE_SCRIPT: '/live/shopping/livescript',
    // savebytype
    SAVE_BY_TYPE: '/business/setting/savebytype',
    // savebytype2
    SAVE_BY_TYPE_2: '/business/setting/savebytype2',
    // listscript
    LIST_SCRIPT: '/live/shopping/listscript',
    // get livescript
    GET_LIVESCRIPT: '/live/shopping/getlivescript',
    // getlivebyposts
    GET_LIVE_BY_POSTS: '/live/index/getlivebyposts',
    // getCommentsLive
    GET_LIVE_COMMENTS: '/live/index/commentslive'
  },
  chatbot: {
    // script
    CHATBOT_SCRIPT: '/chatbot/script',
    CHATBOT_SCRIPT_LIST: '/chatbot/script/list',
    CHATBOT_SCRIPT_LOAD_BOT: '/chatbot/script/loadbot',
    CHATBOT_SCRIPT_ADD_BOT: '/chatbot/script/addbot',
    CHATBOT_SCRIPT_UPDATE_BOT: '/chatbot/script/updatebot',
    CHATBOT_SCRIPT_REMOVE_BOT: '/chatbot/script/removebot',
    CHATBOT_SCRIPT_REMOVE_CONNECT_PAGE: '/chatbot/script/removeconnectpage',
    CHATBOT_SCRIPT_ADD_GROUP: '/chatbot/script/addgroup',
    CHATBOT_SCRIPT_UPDATE_GROUP: '/chatbot/script/updategroup',
    CHATBOT_SCRIPT_REMOVE_GROUP: '/chatbot/script/removegroup',
    CHATBOT_SCRIPT_LIST_GROUP: '/chatbot/script/listgroup',
    CHATBOT_SCRIPT_ADD_BLOCK: '/chatbot/script/addblock',
    CHATBOT_SCRIPT_UPDATE_BLOCK: '/chatbot/script/updateblock',
    CHATBOT_SCRIPT_REMOVE_BLOCK: '/chatbot/script/removeblock',
    CHATBOT_SCRIPT_CLONE_BLOCK_GROUP: '/chatbot/script/cloneblockgroup',
    CHATBOT_SCRIPT_ADD_CARD: '/chatbot/script/addcard',
    CHATBOT_SCRIPT_UPDATE_CARD: '/chatbot/script/updatecard',
    CHATBOT_SCRIPT_REMOVE_CARD: '/chatbot/script/removecard',
    CHATBOT_SCRIPT_GET_MESSAGE: '/chatbot/script/getmessage',
    CHATBOT_SCRIPT_ADD_MESSAGE: '/chatbot/script/addmessage',
    CHATBOT_SCRIPT_UPDATE_MESSAGE: '/chatbot/script/updatemessage',
    CHATBOT_SCRIPT_PUSH_TO_META: '/chatbot/script/pushscripttometa',
    CHATBOT_SCRIPT_API_TEST: '/chatbot/script/scriptapitest',
    CHATBOT_SCRIPT_MESSAGE_REMOVE: '/chatbot/scriptmessage/remove',
    CHATBOT_SCRIPT_MESSAGE_SAVE_CAMPAIGN_MESSAGES: '/chatbot/scriptmessage/savecampaignmessages',
    // AI
    CHATBOT_AI_ACCOUNT: '/chatbot/ai/account',
    CHATBOT_AI_KNOWLEDGE: '/chatbot/ai/knowledge',
    CHATBOT_AI_LIST_ASSISTANTS: '/chatbot/ai/listassistant',
    CHATBOT_AI_REPORT_ASSISTANT: '/chatbot/ai/reportassistant',
    CHATBOT_AI_ACCOUNTS: '/chatbot/ai/accounts',
    CHATBOT_AI_ADD_ACCOUNT: '/chatbot/ai/addaccount',
    CHATBOT_AI_EDIT_ACCOUNT: '/chatbot/ai/editaccount',
    CHATBOT_AI_DELETE_ACCOUNT: '/chatbot/ai/deleteaccount',
    CHATBOT_AI_CHANGE_ACCOUNT_STATUS: '/chatbot/ai/changestatus',
    CHATBOT_AI_KNOWLEDGE_LIST: '/chatbot/ai/knowledgelist',
    CHATBOT_AI_ADD_KNOWLEDGE: '/chatbot/ai/addknowledge',
    CHATBOT_AI_FILE_KNOWLEDGE_LIST: '/chatbot/ai/fileknowgelist',
    CHATBOT_AI_KNOWLEDGE_TEXT_LIST: '/chatbot/ai/knowledgetextlist',
    CHATBOT_AI_REMOVE_KNOWLEDGE: '/chatbot/ai/removeknowledge',
    CHATBOT_AI_REMOVE_KNOWLEDGE_TEXT: '/chatbot/ai/removeknowledgetext',
    CHATBOT_AI_REMOVE_KNOWLEDGE_FILE: '/chatbot/ai/removefileknowledge',
    CHATBOT_AI_SAVE_FILE_EMBEDDING: '/chatbot/ai/savefileembedding',
    CHATBOT_AI_ASSISTANT_LIST: '/chatbot/ai/assistantlist',
    CHATBOT_AI_GET_ASSISTANT_BY_ID: '/chatbot/ai/getassistantbyid',
    CHATBOT_AI_CREATE_ASSISTANT: '/chatbot/ai/createassistant',
    CHATBOT_AI_UPDATE_ASSISTANT: '/chatbot/ai/updateassistant',
    CHATBOT_AI_REMOVE_ASSISTANT: '/chatbot/ai/removeassistant',
    CHATBOT_AI_CHAT_ASSISTANT_PREVIEW: '/chatbot/ai/chatassistantpreview',
    CHATBOT_AI_LIST_MESSAGE_PREVIEW: '/chatbot/ai/listmessagepreview',
    CHATBOT_AI_CLEAR_MESSAGE_PREVIEW: '/chatbot/ai/clearmessagepreview',
    CHATBOT_AI_INDUSTRY_CATEGORIES: '/chatbot/ai/industrycategories',
    CHATBOT_AI_INDUSTRY_CATEGORY_PROMPT: '/chatbot/ai/industrycategoryprompt',
    CHATBOT_AI_SEARCH_KNOWLEDGE_PRODUCTS: '/chatbot/ai/knowledgesearchproducts',
    CHATBOT_AI_LIST_KNOWLEDGE_PRODUCTS: '/chatbot/ai/listknowledgeproducts',
    CHATBOT_AI_ADD_KNOWLEDGE_PRODUCTS: '/chatbot/ai/addknowledgeproducts',
    CHATBOT_AI_REMOVE_KNOWLEDGE_PRODUCT: '/chatbot/ai/removeknowledgeproduct',
    // keyword
    CHATBOT_KEYWORD: '/chatbot/keyword',
    // comment
    CHATBOT_COMMENT: '/chatbot/comment',
    CHATBOT_COMMENT_LIST: '/chatbot/comment/list',
    CHATBOT_COMMENT_UPDATE: '/chatbot/comment/update',
    CHATBOT_COMMENT_REMOVE: '/chatbot/comment/remove',
    // campaign
    CHATBOT_CAMPAIGN_LIST: '/chatbot/campaign/list',
    CHATBOT_CAMPAIGN_LIST_USER: '/chatbot/campaign/listuser',
    CHATBOT_CAMPAIGN_ADD: '/chatbot/campaign/add',
    CHATBOT_CAMPAIGN_UPDATE: '/chatbot/campaign/update',
    CHATBOT_CAMPAIGN_REMOVE: '/chatbot/campaign/remove',
    CHATBOT_CAMPAIGN_LIST_LOGS: '/chatbot/campaign/listlogs',
    CHATBOT_CAMPAIGN_ADD_LOG: '/chatbot/campaign/addlog',
    CHATBOT_CAMPAIGN_UPDATE_USER: '/chatbot/campaign/updatecampaignuser',
    CHATBOT_CAMPAIGN_COUNT_USER: '/chatbot/campaign/countuser',
    CHATBOT_CAMPAIGN_SEND_MESSAGE: '/chatbot/campaign/sendmessage',
    // script schedule
    CHATBOT_SCRIPT_SCHEDULE_LIST_CAMPAIGN: '/chatbot/chasescript/listcampaign',
    CHATBOT_SCRIPT_SCHEDULE_ADD_CAMPAIGN: '/chatbot/chasescript/addcampaign',
    CHATBOT_SCRIPT_SCHEDULE_UPDATE_CAMPAIGN: '/chatbot/chasescript/updatecampaign',
    CHATBOT_SCRIPT_SCHEDULE_REMOVE_CAMPAIGN: '/chatbot/chasescript/removecampaign',
    CHATBOT_SCRIPT_SCHEDULE_GET_CAMPAIGN: '/chatbot/chasescript/getcampaign',
    CHATBOT_SCRIPT_SCHEDULE_ADD_SCHEDULE: '/chatbot/chasescript/addschedule',
    CHATBOT_SCRIPT_SCHEDULE_LIST_SCHEDULE: '/chatbot/chasescript/listschedule',
    CHATBOT_SCRIPT_SCHEDULE_UPDATE_SCHEDULE: '/chatbot/chasescript/updateschedule',
    CHATBOT_SCRIPT_SCHEDULE_REMOVE_SCHEDULE: '/chatbot/chasescript/removeschedule',
    CHATBOT_SCRIPT_SCHEDULE_REPORT_SCHEDULE: '/chatbot/chasescript/reportschedule',
    CHATBOT_SCRIPT_SCHEDULE_COUNT_SENT_MSG: '/chatbot/chasescript/countsentmsg',
    CHATBOT_SCRIPT_SCHEDULE_IMPORT_LOGS: '/chatbot/chasescript/importlogs',
    CHATBOT_SCRIPT_SCHEDULE_DELETE_IMPORT_LOGS: '/chatbot/chasescript/deletelogsimport',
    CHATBOT_SCRIPT_SCHEDULE_VIEW_LOG_QUEUE: '/chatbot/chasescript/viewlogqueue',
    // menu
    CHATBOT_MENU: '/chatbot/menu',
    // marketing
    CHATBOT_MARKETING_INDEX: '/chatbot/marketing',
    CHATBOT_MARKETING_LOAD_PAGE_ACCOUNT: '/chatbot/marketing/loadpageaccount',
    CHATBOT_MARKETING_LIST: '/chatbot/marketing/list',
    CHATBOT_MARKETING_DETAIL_FB_AUDIENCES: '/chatbot/marketing/detailfbaudiences',
    CHATBOT_MARKETING_SAVE_AUDIENCE_REPORT: '/chatbot/marketing/savereportadmin',
    CHATBOT_MARKETING_SYNC_AUDIENCES: '/chatbot/marketing/aynsaudiences',
    CHATBOT_MARKETING_UPDATE_SEGMENT: '/chatbot/marketing/updatesegment',
    CHATBOT_MARKETING_IMPORT_AUDIENCE: '/chatbot/marketing/importaudience',
    CHATBOT_MARKETING_CUSTOMER_POS: '/chatbot/marketing/customerpos',
    CHATBOT_MARKETING_SEARCH_USER_POS: '/chatbot/marketing/searchuserpos',
    CHATBOT_MARKETING_DELETE: '/chatbot/marketing/delete',
    CHATBOT_MARKETING_LIST_CAMPAIGN: '/chatbot/marketing/listcampaign',
    CHATBOT_MARKETING_LIST_CUSTOMER: '/chatbot/marketing/listcustomer',
    CHATBOT_MARKETING_SYNC_TOKEN: '/chatbot/marketing/syntoken',
    CHATBOT_MARKETING_LIST_CART: '/chatbot/marketing/listcart',
    CHATBOT_MARKETING_DELETE_CART: '/chatbot/marketing/deletecart',
    CHATBOT_MARKETING_LIST_PRODUCT_CART: '/chatbot/marketing/listproductcart',
    CHATBOT_MARKETING_SAVE_CART: '/chatbot/marketing/savecart',
    CHATBOT_MARKETING_CAMPAIGN: '/chatbot/marketing/campaign',
    CHATBOT_MARKETING_CAMPAIGN_USER: '/chatbot/marketing/campaignUser',
    CHATBOT_MARKETING_LOGS: '/chatbot/marketing/logs',
    CHATBOT_MARKETING_VIEW_LOG: '/chatbot/marketing/viewlog',
    CHATBOT_MARKETING_CREATE_ADS: '/chatbot/marketing/createads',
    CHATBOT_MARKETING_ADD_CAMPAIGN: '/chatbot/marketing/addcampaign',
    CHATBOT_MARKETING_DETAIL_SEGMENT: '/chatbot/marketing/detailsegment',
    CHATBOT_MARKETING_ESTIMATE_CAMPAIGN: '/chatbot/marketing/estimatecampaign',
    CHATBOT_MARKETING_SEND_CAMPAIGN: '/chatbot/marketing/sendcampaign',
    CHATBOT_MARKETING_PREVIEW_MESSAGE: '/chatbot/pagemessagepreviews/check',
    CHATBOT_MARKETING_CREATE_ALIAS: '/chatbot/marketing/createalias',
    CHATBOT_MARKETING_DELETE_CAMPAIGN: '/chatbot/marketing/deletecampaign',
    CHATBOT_MARKETING_LOAD_INSIGHT_FMM: '/chatbot/marketing/loadinsightfmm',
    CHATBOT_MARKETING_BATCH_LIST: '/chatbot/marketing/batchlist',
    CHATBOT_MARKETING_STOP_CAMPAIGN: '/chatbot/marketing/stopcampaign',
    CHATBOT_MARKETING_UPLOAD_IMAGE_HASH: '/chatbot/marketing/uploadimagehash',
    // report
    CHATBOT_REPORT_INDEX: '/chatbot/report',
    CHATBOT_REPORT_MESSAGE: '/chatbot/report/message',
    CHATBOT_REPORT_FEEDBACK: '/chatbot/report/feedback',
    CHATBOT_REPORT_CAMPAIGN_USER: '/chatbot/report/campaignuser',
    // setting
    CHATBOT_SETTING_INDEX: '/chatbot/setting',
    CHATBOT_SETTING_CONVERSATION: '/chatbot/setting/conversation',
    CHATBOT_SETTING_SHARE: '/chatbot/setting/share',
    // utility message
    UTILITY_MESSAGE_LIST: '/chatbot/utilitymessage/list',
    UTILITY_MESSAGE_UPDATE: '/chatbot/utilitymessage/update',
    UTILITY_MESSAGE_UPLOAD_IMG: '/chatbot/utilitymessage/uploadImage',
    UTILITY_MESSAGE_ADD: '/chatbot/utilitymessage/add',
    UTILITY_MESSAGE_DELETE: '/chatbot/utilitymessage/remove'
  },
  order: {
    ORDER_INDEX: '/order',
    ORDER_DRAFT: '/order/draft',
    ORDER_DRAFT_LIST: '/chat/orderdraftlist',
    ORDER_DRAFT_UPDATE: '/chat/updateorderdraft',
    ORDER_DRAFT_INFO: '/chat/getinfobyorderdraft',
    ORDER_DRAFT_CREATE_NHANH: '/chat/createordernhanh',
    ORDER_DRAFT_CHECKOUT_LINK: '/chat/getlinkcheckout',
  },
  sys: {
    SYS_INDEX: '/sys',
    SYS_PAGES: '/admin/page/list',
    SYS_USERS: '/admin/user/list',
    SYS_PAYMENT: '/admin/payment/list',
    SYS_REPORT_USER: '/admin/report/user',
    SYS_REPORT_PAGE_CONVERSATION: '/admin/report/conversation',
    SYS_REPORT_FBEVENT: '/admin/meta/reportevent',
    SYS_BLOGS: '/sys/blogs',
    SYS_AUTHOR: '/sys/author',
    SYS_MOBILE_APP: '/sys/mobile-app',
    SYS_MANUAL: '/sys/manual',
    SYS_PROXY: '/sys/proxy',
    SYS_BANNER: '/admin/banner/list',
    SYS_REPORT_FMM: '/sys/report-fmm',
  },
  system: {
    ANNOUNCEMENT_VIEW: '/system/announcement/view',
    ANNOUNCEMENT_LIST: '/system/announcement/list',
    ANNOUNCEMENT_LIST_V2: '/announcement/list',
    ANNOUNCEMENT_DETAIL_V2: '/announcement/detail',
  },
  settings: {
    FBAD_ADACCOUNT: '/setting/fbad/adaccount',
    SETTING_INDEX: '/setting',
    SETTING_GENERAL: '/setting/general/index',
    SETTING_CONVERSATION: '/setting/conversation/index',
    SETTING_PAGE_LIST: '/setting/page/list',
    SETTING_USER: '/setting/user/index',
    SETTING_MANAGE_POSTS: '/setting/manageposts/index',
    SETTING_MANAGE_POST_PULL: '/setting/manageposts/pullpost',
    SETTING_MANAGE_POST_COUNT: '/setting/manageposts/postcount',
    SETTING_MANAGE_POST_SETTING: '/setting/manageposts/postsetting',
    SETTING_MANAGE_POST_HIDE_COMMENTS: '/setting/manageposts/hidecomments',
    SETTING_MANAGE_POST_SHOW_COMMENTS: '/setting/manageposts/showcomments',
    SETTING_MANAGE_POST_SYNC: '/setting/manageposts/syncpostapi',
    SETTING_MANAGE_PAGE: '/setting/managepage/index',
    SETTING_META_SM: '/setting/metasmc/index',
    SETTING_SEND_PURCHASE: '/setting/sendpurchase/index',
    SETTING_AFFILIATE: '/setting/affiliate/index',
    SETTING_AFFILIATE_LIST_CONNECT: '/setting/affiliate/listconnect',
    SETTING_AFFILIATE_SETTING: '/setting/affiliate/setting',
    SETTING_AFFILIATE_GET_FEED: '/chat/facebook/getfeed',
    SETTING_AFFILIATE_SAVE_SHARE_POST: '/setting/affiliate/savesharepost',
    SETTING_AFFILIATE_CONNECT: '/setting/affiliate/connect',
    SETTING_AFFILIATE_UPDATE_SHARE_POST: '/setting/affiliate/updatesharepost',
    SETTING_AFFILIATE_REMOVE_SHARE_POST: '/setting/affiliate/removesharepost',
    SETTING_AFFILIATE_REMOVE_CONNECT: '/setting/affiliate/removeconnect',
    SETTING_LOG: '/setting/log/index',
    SETTING_EXTENSION: '/setting/extension/index',
    SETTING_DIVISION: '/setting/split/index',
    SETTING_DIVISION_UPDATE: '/setting/split/update',
    SETTING_DIVISION_LIST: '/setting/split/settinglist',
    SETTING_DIVISION_GROUPS: '/setting/split/groups',
    SETTING_TAG: '/setting/tag/index',
    SETTING_QUICK_MSG: '/setting/quickmsg/index',
    SETTING_ECOM_CUSTOMER_CARE: '/setting/ecomcustomercare/index',
    SETTING_FORM: '/setting/form/index',
    SETTING_USER_INDEX: '/setting/user/index',
    SETTING_USER_ADD_USER_NHANH: '/setting/user/addusernhanh',
    SETTING_USER_UPDATE: '/setting/user/update',
    SETTING_USER_ROLE_GROUP: '/setting/user/rolegroup',
    SETTING_USER_ROLE_PERMISSIONS: '/setting/user/rolepermissions',
    SETTING_USER_UPDATE_USER_PAGE: '/setting/user/updateuserpage',
    SETTING_USER_REMOVE: '/setting/user/remove',
    SETTING_USER_CHECK_ASSIGNED: '/setting/user/checkuserassigned',
    SETTING_BUSINESS_AD_ACCOUNT: '/setting/businessadaccount/index',
  },
  business: {
    PAGE_GET_INFO: '/business/page/getpageinfo',
    TAG_ALL: '/business/tag/all',
    ATTACHMENT_UPLOAD2CLOUD: '/business/attachment/upload2cloud',
    MANAGE_GOOGLE_SHEET_GENERATE_AUTH_URL: '/store/manage/googlesheetgenerateauthurl',
    MANAGE_GOOGLE_SHEET_LOAD: '/store/manage/googlesheetload',
    BUSINESS_USER_LIST: '/business/user/list',
    BUSSINESS_TAG_GROUP: '/business/taggroup/handlegroup',
    PAGE_TRANSFER_EXPIRED_DATE: '/business/page/transferpageexpireddate',
    PAGE_REMOVE_FROM_BUSINESS: '/business/page/removepageformbusiness',
    PAGE_TRANSFER_BUSINESS: '/business/page/transferpagebusiness',
    PAGE_UPDATE_ALIAS_NAME: '/business/page/updatepagealiasname',
    PAGE_SYNC_SETTING: '/business/page/syncsettingpage',
    PAYMENT_CREATE: '/api/payment/createpayment',
    BUSSINESS_SETTING_LIST: '/business/setting/getsettinglist'
  },
  ads: {
    INDEX: '/ads',
    VAT_BILLING: '/ads/meta/vatbilling',
    CHECK_CONTENT: '/ads/meta/checkcontent',
    CHECK_CLONE: '/ads/meta/checkclone',
    UPLOAD_FILE: '/ads/meta/uploadfile',
    CREATE_CHECK_CONTENT: '/ads/meta/savejobcontent',
    DELETE_CHECK_CONTENT: '/ads/meta/deletejobcontent',
    LIST_JOB_USER: '/ads/meta/listjobuser',
    BLOCK_USER: '/ads/meta/lockscanusers',
    TAG_GROUPS: '/ads/meta/listtaggroups',
    ADD_TAG_TO_USERS: '/ads/meta/addtagscanusers',
    SCAN_USER: '/ads/meta/filterscan',
    CREATE_USER_SCAN: '/ads/meta/createuserscan',
    IMPORT_SCAN_ITEMS: '/ads/meta/importscanitems',
    READ_SCAN_RECORD: '/ads/meta/readscanrecords'
  },
  genai: {
    ASSISTANT_LIST: '/genai/assistantlist',
  }
};

export const URI_PUBLIC = {
  FORM: '/form',
  widgetView: '/livescm',
  CHECKOUT: '/checkout',
}
